<template>
    <div class="table-container">
        <el-table
            :data="news"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column
                prop="title"
                label="标题"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <div class="title">
                        <el-popover
                        v-if="scope.row.cover"
                        placement="right"
                        width="300"
                        trigger="click">
                            <el-image :src="scope.row.cover.path" fit="fill"/>
                            <i class="el-icon-picture-outline-round" slot="reference" />
                        </el-popover>
                        {{scope.row.title}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="is_published"
                label="已发布"
                width="90"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="created_at"
                label="创建时间"
                width="140"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';

const states = {
    '所有': null,
    '已发布': true,
    '未发布': false
}

export default {
    name: "NewsTable",
    mixins: [pageMixin, fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            news: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const {filter} = this.$parent;
            const state = states[filter.state];
            if(state!==null){
                if(state){
                    query.compare('is_published', '=' ,true)
                }else{
                    query.compare('is_published', '!=' ,true)
                }
            }
            if(filter.keyword){
                query.contains('title', filter.keyword.trim())
            }
            this.$ox
                .service("article")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    orderBy: ["-created_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.news = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        edit(row) {
            this.$parent.$refs.dialog.show(row)
        },
        remove(row){
            this.$ox.service('article').delete(row.id).then(()=>{
                this.news = this.news.filter(item=>item.id!==row.id)
                this.$notify.success({
                  title: '操作成功',
                  message: `文章“${row.title}”已删除`
                });
            })
        }
    }
};
</script>

<style scoped>
.title{
    display: flex;
    justify-content:flex-start;
    align-items:center;
}
.title i{
    font-size:16px;
    color: #409EFF;
    display: inline-block;
    flex-shrink:0;
    flex-grow:0;
    margin-right:5px;
    cursor: pointer;
    vertical-align:middle;
    line-height:21px;
}
</style>
